'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var NavBrand = require('../components/NavBrand.js');
var MobileSidebar = require('./MobileSidebar/MobileSidebar.js');
require('./MobileNavbar.scss.js');
var NavbarProfile = require('./NavbarProfile/NavbarProfile.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MobileNavbar = function () {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    return (React__default['default'].createElement("nav", { className: "mn-navigation" },
        React__default['default'].createElement("div", { className: "container" },
            React__default['default'].createElement("div", { className: "nav_burger", onClick: function () { return setIsOpen(true); } },
                React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--burger burger_icon" })),
            React__default['default'].createElement(NavBrand.NavBrand, null),
            React__default['default'].createElement(NavbarProfile.NavbarProfile, null)),
        isOpen &&
            React__default['default'].createElement(MobileSidebar, { onCloseClick: function () { return setIsOpen(false); } })));
};

exports.MobileNavbar = MobileNavbar;
//# sourceMappingURL=MobileNavbar.js.map
